import { FieldValues } from 'react-hook-form';
import evaluateExpression from '@/helpers/evaluateExpression';
import { BoxIndexRule } from './parseBoxIndexRules';
import evaluateListFilter from './evaluateListFilter';
import getFilteredListIndex from './getFilteredListIndex';
import canRunAutofillOnRow from '../../../helpers/canRunAutofillOnRow';

const processWithRules = ({
  rules,
  indexNumber,
  formValues,
  masterFieldKey,
}: {
  rules: Array<BoxIndexRule>,
  indexNumber: number,
  formValues: FieldValues,
  masterFieldKey: string,
  }): unknown => {
  const item = formValues[masterFieldKey][indexNumber];
  for (let i = 0; i < rules.length; i += 1) {
    const rule = rules[i];
    if (!canRunAutofillOnRow(item)) {
      return null;
    }

    if (rule.operator === 'field-equals' && item[rule.checkField] === rule.checkValue) {
      return rule.value;
    }

    if (rule.operator === 'box-index-expression') {
      if (evaluateListFilter(item, rule.expression, rule.checkField)) {
        const index = getFilteredListIndex(item, rule.expression, rule.checkField, formValues[masterFieldKey]);
        if (index !== undefined && index !== null) {
          return evaluateExpression({
            expression: rule.valueExpression,
            id: 'processWithRules',
            variables: { boxIndex: index },
          });
        } if (index === null) {
          return null;
        }
        console.error('item does not exist in filtered list despite matching list filter expression');
      }
    }
    if (rule.operator === 'default') {
      return rule.value;
    }
  }
  return undefined;
};

export default processWithRules;
